import { Dispatch, SetStateAction, createContext } from "react";
import { CREATE_POST_MODAL_WIDTH } from "../../../../../utils";
import { Modal } from "../../../../Common";
import { CreateRepostModalContent } from "./CreateRepostContent";

type CreateRepostProps = {
  createRePostOpen: boolean;
  setCreateRePostOpen: Dispatch<SetStateAction<boolean>>;
};

export const CreateRepostContext = createContext({} as CreateRepostProps);
export const CreateRepost = (props: CreateRepostProps) => {
  const { createRePostOpen, setCreateRePostOpen } = props;

  if (!createRePostOpen) return null;

  return (
    <Modal
      from="create-repost"
      type="Pages"
      showCloseButton={true}
      setCloseButton={setCreateRePostOpen}
      maxWidth={CREATE_POST_MODAL_WIDTH}
    >
      <CreateRepostContext.Provider value={{ ...props }}>
        <CreateRepostModalContent />
      </CreateRepostContext.Provider>
    </Modal>
  );
};
